import * as THREE from 'three';
import p5 from "p5";
import { Params } from '../../data/Params';
import { QTree } from './QTree';
import { DrawerBase } from './DrawerBase';
import { basename } from 'path';
import { QTreeRect } from './QTreeRect';
import { Utils } from '../../data/Utils';
import { Random } from '../../data/Random';

export class GridDrawer extends DrawerBase{

    p5:p5;
    qTree:QTree;

    constructor(tgt:p5){
        super();

        this.p5 = tgt;
        //this.qTree = new QTree();
        //this.qTree.update(5);

        let ww = 512;//Params.resolution;
        let hh = 512;
        let numX = 5;
        let numY = 5;
        if(Random.value<0.5){
            numX = 7;
            numY = 7;
        }

        this.rects = [];

        let idx = 0;

        for(let j=0;j<numY;j++){
            for(let i=0;i<numX;i++){
                let spaceX = ww/numX;
                let spaceY = hh/numY;
                let rect = new QTreeRect(i*spaceX,j*spaceY,spaceX,spaceY,0);
                
                rect.setRule( Params.rules[idx%Params.rules.length] );
                idx++;

                this.rects.push(rect);
            }
        }

        Utils.swapRandomly(this.rects,0.3);

    }

    show(): void {
        super.show();
        this.count=0;
    }

    hide(): void {
        super.hide();
    }

    update(){
        
        let rect = this.rects[this.count%this.rects.length];
        if(this.count<this.rects.length) rect.show();

        for(let i=0;i<this.rects.length;i++){
            this.rects[i].update(this.p5);
        }
        this.count++;
        
    }

}